var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAffirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 28,
    viewBox: "0 0 68 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03381 24.7169C4.20795 24.7169 3.78723 24.3113 3.78723 23.6446C3.78723 22.4014 5.17716 21.9833 7.71238 21.7145C7.71238 23.3711 6.58891 24.7169 5.02601 24.7169H5.03381ZM6.12456 15.4003C4.31235 15.4003 2.22902 16.2503 1.09775 17.1501L2.13085 19.3259C3.03773 18.4975 4.50401 17.7889 5.82694 17.7889C7.08442 17.7889 7.77938 18.2085 7.77938 19.0539C7.77938 19.6211 7.31971 19.9086 6.45022 20.0221C3.19978 20.4417 0.6521 21.3368 0.6521 23.8342C0.6521 25.8141 2.0654 27.0123 4.2734 27.0123C5.85031 27.0123 7.25271 26.1389 7.91962 24.992V26.7015H10.8584V19.5388C10.8584 16.586 8.80313 15.394 6.12611 15.394L6.12456 15.4003Z",
    fill: "#101820"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6204 15.7222V26.6878H38.7648V21.4039C38.7648 18.8941 40.2888 18.1559 41.3499 18.1559C41.8276 18.1522 42.2957 18.2901 42.6947 18.5522L43.2696 15.6539C42.8241 15.476 42.3471 15.3898 41.8673 15.4006C40.2514 15.4006 39.2354 16.1139 38.5654 17.5654V15.7222H35.6204Z",
    fill: "#101820"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8412 15.4006C56.1786 15.4006 54.9352 16.3797 54.2885 17.3246C53.6886 16.1046 52.4187 15.4006 50.8916 15.4006C49.2305 15.4006 48.079 16.3206 47.5477 17.3805V15.7223H44.5154V26.6879H47.663V21.0419C47.663 19.0216 48.7272 18.0441 49.7198 18.0441C50.6189 18.0441 51.4448 18.6238 51.4448 20.1204V26.6879H54.5861V21.0419C54.5861 18.9921 55.6239 18.0441 56.6632 18.0441C57.4953 18.0441 58.3773 18.6471 58.3773 20.0986V26.6879H61.5186V19.1071C61.5186 16.6439 59.856 15.4006 57.8475 15.4006",
    fill: "#101820"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.968 15.7221H25.1196V14.6078C25.1196 13.1563 25.9501 12.7429 26.6653 12.7429C27.1537 12.7493 27.6338 12.869 28.0677 13.0926L29.037 10.8811C29.037 10.8811 28.0537 10.2408 26.2664 10.2408C24.2579 10.2408 21.972 11.3707 21.972 14.9155V15.7221H17.2116V14.6078C17.2116 13.1563 18.0406 12.7429 18.7574 12.7429C19.2466 12.7429 19.7282 12.863 20.1598 13.0926L21.129 10.8811C20.5509 10.5439 19.6206 10.2408 18.36 10.2408C16.3515 10.2408 14.0656 11.3707 14.0656 14.9155V15.7221H12.2456V18.1402H14.0703V26.6876H17.2116V18.1402H21.9782V26.6876H25.1196V18.1402H27.968V15.7221Z",
    fill: "#101820"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9818 15.7219H29.8435V26.6828H32.9818V15.7219Z",
    fill: "#101820"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9592 13.8589H33.0336C34.8271 8.23471 40.9119 3.2912 48.1483 3.2912C56.9491 3.2912 64.5548 9.97372 64.5548 20.3767C64.5815 22.5121 64.2874 24.6394 63.6822 26.6878H66.6661L66.6958 26.5852C67.1986 24.5573 67.4467 22.475 67.4343 20.386C67.4343 8.78486 58.9576 0.434814 48.1545 0.434814C39.6685 0.434814 32.1049 6.30921 29.9608 13.862L29.9592 13.8589Z",
    fill: "#4A4AF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffirm);
export default __webpack_public_path__ + "static/media/affirm.444a68fea5ac565c31787f53b3993026.svg";
export { ForwardRef as ReactComponent };